var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_vm.absolute ? 'absolute top-0 right-0 m-12' : '') + ' inline-flex items-center cursor-pointer',
    on: {
      "click": function ($event) {
        return _vm.$emit('helpClick');
      }
    }
  }, [_c('svg', {
    staticClass: "h-6 w-6 text-pink-600",
    attrs: {
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ml-2 text-base font-normal text-indigo-600"
  }, [_vm._v("\n    Aide\n  ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }